import ApiHandler from "../libs/ApiHandler";
import Vue from "vue";
import VueAxios from "vue-axios";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
import { getGenericAuthModel, removeAuth } from "../utils/sessionStoreAuth";
import qs from "qs";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

axios.interceptors.request.use(
  config => {
    if (config.headers.common["X-INTERNAL-KEY"] == null) {
      let token = getGenericAuthModel("Token")();
      if (token !== undefined) {
        config.headers.common["X-INTERNAL-KEY"] = token;
      } else {
        pushLoginPage();
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  config => {
    return config;
  },
  error => {
    if (error.response !== undefined) {
      if (error.response.status === 401 && error.response.config.url.includes('Authenticate')) return Promise.reject({
        ...error,
        showToast: true
      });
      else if (error.response.status === 401) pushErrorPage(error.response.status);
      else if (error.response.status === 403) pushLoginPage();
    }
    return Promise.reject(error);
  }
);

function pushErrorPage(status) {
  let route = router.currentRoute;
  if (route.name !== "errors") {
    router.push({
      name: "errors",
      params: {
        code: status,
        description: "Você não possui permissão para acessar esse recurso."
      }
    });
  }
}

function pushLoginPage() {
  let route = router.currentRoute;
  if (route.name !== "login" && route.name !== "forgot-password") {
    // Prevents duplicated navigation.
    let token = getGenericAuthModel("Token")();
    let error;
    if (token !== undefined) error = "sessionExpired";
    else error = "credentialsNeeded";
    removeAuth();

    let query = {
      nextUrl: route.name,
      error: error,
      ...route.query
    };

    router.push({
      name: "login",
      params: route.params,
      query: query
    });
  }
}

const store = new Vuex.Store({
  state: {
    CommissionCompetence: [],
    Filters: {
      merchants: {}
    }
  },
  mutations: {
    SET_COMMISSION_COMPETENCE_LIST(state, payload) {
      state.CommissionCompetence = payload;
    },
    SET_FILTERS: (state, payload) => {
      state.Filters = payload;
    }
  },
  getters: {
    CommissionCompetence(state) {
      return state.CommissionCompetence;
    },
    Filters(state) {
      return state.Filters;
    }
  },
  actions: {
    //#region Access
    AddAccessControl(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/AccessControl/Add`), payload.module)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAccessControl(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/AccessControl/Delete`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAccessControl(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/AccessControl/Get?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAccessControl(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccessControl/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAccessControl(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccessControl/Update`), payload.module)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddAccessAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/AccessAction/Add`), payload.action)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAccessAction(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/AccessAction/Delete`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAccessAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/AccessAction/Get?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAccessAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccessAction/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAccessAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccessAction/Update`), payload.action)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Authenticate
    Authenticate(_context, payload) {
      return new Promise((resolve, reject) => {

        axios.post(ApiHandler.URL(`/AuthenticationInternal/Authenticate`), payload,
          {
            headers: {
              Authorization: `Bearer ${payload.token}`,
              'Content-Type': 'application/json'
            }
          }).then(
          response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          },
          error => {
            reject(error);
          }
        );
      });
    },
    CreatePassword(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL(`/AuthenticationInternal/CreatePassword`), payload).then(
          response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          },
          error => {
            reject(error);
          }
        );
      });
    },
    LostPassword(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AuthenticationInternal/LostPassword"), {
            params: payload
          })
          .then(
            response => {
              if (response.data.HasError) {
                reject(response.data);
              } else {
                resolve(response.data.ResponseDetail);
              }
            },
            error => {
              reject(error);
            }
          );
      });
    },
    Logoff(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL(`/AuthenticationInternal/Logoff?token=${payload.token}`)).then(
          response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          },
          error => {
            reject(error);
          }
        );
      });
    },
    //#endregion

    //#region Campaign
    AddCampaign(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Campaign/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCampaign(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/Campaign/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCampaign(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Campaign/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCampaign(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Campaign/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCampaignMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Campaign/ListMerchant"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateCampaign(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Campaign/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region ChangeManagement

    AddChangeManagement(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/ChangeManagement/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteChangeManagement(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/ChangeManagement/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetChangeManagement(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ChangeManagement/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListChangeManagement(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/ChangeManagement/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateChangeManagement(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/ChangeManagement/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AddChangeManagementHistory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/ChangeManagementHistory/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListChangeManagementHistory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/ChangeManagementHistory/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Chargeback

    ListChargeback(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Chargeback/List`), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetDashboard(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Chargeback/GetDashboard`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBrand(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Chargeback/GetBrand"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportBrand(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Chargeback/ReportBrand`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetChargebackMarketplaceDashboard(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Chargeback/GetMarketplace`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ChargebackListSubaccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Chargeback/ListSubaccount`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportSubaccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Chargeback/ReportSubaccount`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Emailage

    ListEmailage(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Emailage/List`), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetEmailage(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Emailage/Get`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region SuspectTransaction
    ListSuspectTransactionStatus(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/SuspectTransactionStatus/List`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CheckTrustable(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/SuspectTransaction/Check`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetSuspectTransaction(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/SuspectTransaction/Get`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListSuspectTransaction(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/SuspectTransaction/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region CreditBureau

    ListCreditBureau(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CreditBureau/List`), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCreditBureau(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CreditBureau/Get`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Fingerprint

    ListFingerprint(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Fingerprint/List`), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListIP(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Fingerprint/ListIP`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region FrequenciaRepasse
    EditarFrequenciaRepasse(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.put(
          ApiHandler.URL("/MerchantPaymentDate/Update"),
          payload,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          if (response.data.HasError) {
            reject(response.data);
          } else {
            resolve(response.data.ResponseDetail);
          }
        })
        .catch(error => {
          reject(error);
        });
      });
    },

    //#endregion
    //#region Classificacao
    ListNichos(_context) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL("/Classificacao/Nicho/List"))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ListNichosPage(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL("/Classificacao/Nicho/ListPage"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ListSegmentos(_context) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL("/Classificacao/Segmento/List"))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ListSegmentosPage(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL("/Classificacao/Segmento/ListPage"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    GetMerchantClassificacao(_context, idMerchant) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL("/Classificacao/Merchant/Get"), { params: { idMerchant } })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    SalvarMerchantClassificacao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL("/Classificacao/Merchant/Save"), payload, {
          headers: { "Content-Type": "application/json" }
        })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    CadastrarNicho(_context, nome) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL("/Classificacao/Nicho/Save"), JSON.stringify(nome), {
          headers: { "Content-Type": "application/json" }
        })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    CadastrarSegmento(_context, nome) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL("/Classificacao/Segmento/Save"), JSON.stringify(nome), {
          headers: { "Content-Type": "application/json" }
        })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    UpdateNicho(_context, nicho) {
      return new Promise((resolve, reject) => {
        axios.put(ApiHandler.URL("/Classificacao/Nicho/Update"), nicho)
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    DeleteNicho(_context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(ApiHandler.URL(`/Classificacao/Nicho/Delete?id=${id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    UpdateSegmento(_context, segmento) {
      return new Promise((resolve, reject) => {
        axios.put(ApiHandler.URL("/Classificacao/Segmento/Update"), segmento)
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    DeleteSegmento(_context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(ApiHandler.URL(`/Classificacao/Segmento/Delete?id=${id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    //#endregion
    //#region CheckingAccount
    ListCheckingAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCheckingAccountMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ListMerchant`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetConsolidated(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/repasse/consolidated`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PostLiberarRemessa(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/repasse/liberarRemessa`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPaymentList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/repasse`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PaymentListReport(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/repasse/report`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCheckingAccountMerchantNegative(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ListMerchantNegative`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCheckingAccountPeriod(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ListPeriod`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAcquirerReceivables(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/AcquirerReceivables`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportCheckingAccountMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ReportMerchant`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportCheckingAccountMerchantNegative(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ReportMerchantNegative`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportCheckingAccountPeriod(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ReportPeriod`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportCheckingAccountPeriodInLot(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CheckingAccount/ReportPeriodInLot`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region CheckingAccountPartner
    ListCheckingAccountPartner(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/CheckingAccountPartner/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCheckingAccountPartnerMerchant(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/CheckingAccountPartner/ListMerchant"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportCheckingAccountPartner(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/CheckingAccountPartner/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region CommissionCompetence
    AddCommissionCompetence(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/CommissionCompetence/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCommissionCompetence(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL(`/CommissionCompetence/Delete`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCommissionCompetence(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/CommissionCompetence/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCommissionCompetence(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CommissionCompetence/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCalculatorCommissionCompetence(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CommissionCompetence/ListCalculator`), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateCommissionCompetence(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/CommissionCompetence/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion CommissionCompetence

    //#region ConfigurationTax
    AddConfigurationTax(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/ConfigurationTax/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteConfigurationTax(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/ConfigurationTax/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetConfigurationTax(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ConfigurationTax/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListConfigurationTax(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/ConfigurationTax/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateConfigurationTax(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/ConfigurationTax/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Brand
    AddBrand(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Brand/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteBrand(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Brand/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBrands(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Brand/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListBrands(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Brand/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateBrand(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Brand/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportBrands(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Brand/Report`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Document
    AddDocument(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Document/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteDocument(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Document/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetDocument(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Document/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListDocument(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Document/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateDocument(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Document/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Holiday
    ListHoliday(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Holiday/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region InternalDashboard
    GetBusinessDashboard() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/InternalDashboard/GetBusiness"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMarketplaceDashboard() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/InternalDashboard/GetMarketplace"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region FinancialAudit
    GetTransactionDivergentTax(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/FinancialAudit/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransactionDivergentTax(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/FinancialAudit/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportTransactionDivergentTax(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/FinancialAudit/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListBankStatement(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BankStatement/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportBankStatement(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BankStatement/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBankAccounts(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/BankAccounts/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Merchant
    AddMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Merchant/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Merchant/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantSplitTax(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Merchant/GetMerchantSplitTax?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Merchant/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantCnae(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Merchant/ListMerchantCnae?idMerchant=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantSearch(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Merchant/ListSearch"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantDocs(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Merchant/ListDocs?idMerchant=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantNotTransacting(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Merchant/ListNotTransacting"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantContract(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Merchant/ListMerchantContract"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ListResponsibleMerchant(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Merchant/ListResponsible?codeSolicitation=${payload.codeSolicitation}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteContractSolicitationMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Merchant/DeleteContractSolicitation"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetContractSolicitationMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Merchant/GetContractSolicitation?codeSolicitation=${payload.codeSolicitation}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Merchant/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateBlockedMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Merchant/UpdateBlocked"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateRemovedMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Merchant/UpdateRemoved"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateChangeEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Merchant/UpdateChangeEmail"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePartnerMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Merchant/UpdatePartner"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ResendEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Merchant/ResendEmail"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ResendTechEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Merchant/ResendTechEmail"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Merchant/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportReagendamentoComposition(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/CheckingAccount/ReportReagendamentoComposition"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ProfitReportMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Merchant/ReportProfit"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantState(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Merchant/ReportState"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantCity(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Merchant/ReportCity"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantNotTransacting(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Merchant/ReportNotTransacting"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantContract(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/Merchant/GetContract`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantPlans() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Merchant/GetPlans`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantNegotiation(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Merchant/ListMerchantNegotiation?Id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantDocStatus() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/MerchantDocStatus/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ValidateMerchant(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/Merchant/Validate`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ValidateChangeEmail(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/Merchant/ValidateChangeEmail`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ClearSessionMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL(`/Merchant/Clear?idMerchant=${payload}`)).then(
          response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          },
          error => {
            reject(error);
          }
        );
      });
    },
    LiberarDadosIntegracao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL(`/Merchant/LiberarDadosIntegracao?idMerchant=${payload}`)).then(
          response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          },
          error => {
            reject(error);
          }
        );
      });
    },
    ListMerchantPaymenthMethod(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantPaymentMethod/List"), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetMerchantPaymenthMethod(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Marketplace/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region MerchandDoc
    AddMerchantDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantDoc/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantDoc/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAllMerchantDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantDoc/GetAll?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantDoc/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAllMerchantDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantDoc/ListAll"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteMerchantDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/MerchantDoc/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/MerchantDoc/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantDocStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MerchantDoc/UpdateStatus"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion MerchantDoc

    //#region MerchantPreview
    ListMerchantPreview(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/MerchantPreview/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantPreviewStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/MerchantPreviewStatus/List`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListRefusedReason() {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/RefusedReason/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantPreviewStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MerchantPreview/UpdateStatus"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantPreview(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantPreview/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantPreviewHistory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            ApiHandler.URL(`/Merchant/ListMerchantPreviewHistory?Object.MerchantPreview.Merchant.Id=${payload.id}`),
            payload
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantPreviewCorrelation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/MerchantPreview/ListCorrelation`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddMerchantPreview(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/MerchantPreview/Add`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion MerchantPreview

    //#region transaction
    ListTransactions(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Transaction/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransactionsDirectly(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Transaction/ListDirectly"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListSingleSales(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/SingleSale/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCreditCardRefused(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Transaction/ListCreditCardRefused"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportCreditCardRefused(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Transaction/ReportCreditCardRefused"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTransaction(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Transaction/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetSingleSale(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/SingleSale/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransactionStatus(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/TransactionStatus/List`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBanks(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/Bank/List`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetEntryTypes(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/EntryType/List`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CancelBankSlip(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            ApiHandler.URL(
              `/Transaction/CancelBankSlip?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            ),
            payload.BankData
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CancelPix(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            ApiHandler.URL(
              `/Transaction/CancelPix?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            ),
            payload.BankData
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CancelCreditCard(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            ApiHandler.URL(
              `/Transaction/CancelCreditCard?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            )
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    WriteOffBankSlip(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            ApiHandler.URL(
              `/Transaction/WriteOffBankSlip?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            )
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SingleSaleWriteOffBankSlip(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            ApiHandler.URL(
              `/SingleSale/WriteOffBankSlip?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            )
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SingleSaleCancelCreditCard(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            ApiHandler.URL(
              `/SingleSale/CancelCreditCard?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            )
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SingleSaleCancelPix(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            ApiHandler.URL(
              `/SingleSale/CancelPix?idTransaction=${payload.idTransaction}&idMerchant=${payload.idMerchant}`
            ),
            payload.BankData
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransactionApplication(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/Transaction/ListApplication`), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListSubaccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Transaction/ListSubaccount`), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListVendors(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Util/Vendor/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransactionCharge(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Transaction/ListCharge"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportTransaction(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Transaction/Report"), {
            params: payload.params,
            paramsSerializer: params => {
              return qs.stringify(params, {
                arrayFormat: "repeat",
                skipNulls: true
              });
            }
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportTransactionDirectly(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Transaction/ReportDirectly"), {
            params: payload.params,
            paramsSerializer: params => {
              return qs.stringify(params, {
                arrayFormat: "repeat",
                skipNulls: true
              });
            }
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region MerchanPlan
    ListMerchantPlans(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Plan/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantPlan(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Plan/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ReportMerchantPlan(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Plan/Report`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Operator
    AddOperator(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Operator/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateOperatorRemoved(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Operator/UpdateRemoved"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListOperator(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Operator/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetOperator(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Operator/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateOperator(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Operator/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BuscarOperadorId(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Operator/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion Operator

    //#region NoteExtract
    ListNoteExtract(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/NoteExtract/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportNoteExtractMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/NoteExtract/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PDFNoteExtract(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/NoteExtract/DownloadRPS"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    XMLNoteExtract(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/NoteExtract/DownloadNFSe"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region NoteExtractPartner
    AddNoteExtractPartner(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/NoteExtractPartner/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetNoteExtractPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/NoteExtractPartner/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListNoteExtractPartner(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/NoteExtractPartner/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportNoteExtractPartner(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/NoteExtractPartner/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListNoteExtractPartnerStatus(_context) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/NoteExtractPartnerStatus/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateNoteExtractPartnerStatus(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/NoteExtractPartner/UpdateStatus"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region PartnerDoc
    AddPartnerDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/PartnerDoc/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PartnerDoc/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAllPartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PartnerDoc/GetAll?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/PartnerDoc/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAllPartnerDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/PartnerDoc/ListAll"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerDocStatusHistories(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/PartnerDocStatusHistory/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeletePartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/PartnerDoc/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportPartnerDoc(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/PartnerDoc/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePartnerDocStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/PartnerDoc/UpdateStatus"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReactivatePartnerDoc(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/PartnerDoc/Reactivate"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Outgo

    GetOutgo(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Outgo/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListOutgo(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Outgo/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportOutgo(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Outgo/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateOutgo(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Outgo/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateEnabledOutgo(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Outgo/UpdateEnabled"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region AdvancePaymentOperation
    AddAdvancePaymentOperation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AdvancePaymentOperation/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAdvancePaymentOperation(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/AdvancePaymentOperation/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAdvancePaymentOperation(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/AdvancePaymentOperation/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAdvancePaymentOperation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AdvancePaymentOperation/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportAdvancePaymentOperation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AdvancePaymentOperation/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAdvancePaymentOperation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/AdvancePaymentOperation/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Training
    AddTraining(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Training/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTraining(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Training/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTraining(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Training/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateTraining(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Training/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region TrainingImprovement
    AddTrainingImprovement(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/TrainingImprovement/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTrainingImprovement() {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/TrainingImprovement/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTrainingImprovementScore(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/TrainingImprovement/ListScore"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region MerchantNote
    AddMerchantNote(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantNote/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantNote(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantNote/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantNote(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNote/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantNote(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNote/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantNote(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MerchantNote/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Partner
    AddPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL("/Partner/Add"), payload.partner)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Partner/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPartnerDashboard(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Partner/GetDashboard"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartner(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Partner/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListSDRs(_context) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Partner/ListSDRs"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerContract(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Partner/ListPartnerContract"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListResponsiblePartner(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Partner/ListResponsible?codeSolicitation=${payload.codeSolicitation}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteContractSolicitationPartner(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Partner/DeleteContractSolicitation"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetContractSolicitationPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Partner/GetContractSolicitation?codeSolicitation=${payload.codeSolicitation}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/Partner/Update"), payload.partner)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateExcludedPartner(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Partner/UpdateExcluded"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePartnerStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Partner/UpdateStatus"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateUserPartnerInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/UserPartner/UpdatePartner"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Partner/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ProfitReportPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Partner/ReportProfit"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PerformanceReportPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Partner/ReportPerformance"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ResendEmailPartner(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Partner/ResendEmail"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPartnerContract(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/Partner/GetContract`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePartnerEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Partner/UpdateEmail"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ValidatePartnerUpdateEmail(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/Partner/ValidateUpdateEmail`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region PaymentMethod
    GetPaymentMethod(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PaymentMethod/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPaymentMethodShow(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/PaymentMethod/ListShow"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPaymentMethodIsEnabledPaginated(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/PaymentMethod/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPaymentMethodIsEnabled() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/PaymentMethod/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePaymentMethod(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/PaymentMethod/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    ListCompositionFeeTypes(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/CompositionFeeType/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCompositionFeeType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/CompositionFeeType/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateCompositionFeeType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL(`/CompositionFeeType/Update`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddCompositionFeeType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/CompositionFeeType/Add`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCompositionFeeType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/CompositionFeeType/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // ServiceType
    ListServiceTypes(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ServiceType/List`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetServiceType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ServiceType/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddServiceType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/ServiceType/Add`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateServiceType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL(`/ServiceType/Update`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteServiceType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/ServiceType/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#region Profit
    GetProfit(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Profit/Get?idMerchant=${payload.idMerchant}&paymentDate=${payload.paymentDate}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListProfitMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Profit/ListMerchant"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportProfitMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Profit/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportProfit(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            ApiHandler.URL(`/Profit/ReportProfit?idMerchant=${payload.idMerchant}&paymentDate=${payload.paymentDate}`),
            payload
          )
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Prospect
    GetProspect(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Prospect/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListProspect(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Prospect/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportProspect(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Prospect/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region ProspectHistory
    ListProspectHistory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/ProspectHistory/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateProspectHistory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/ProspectHistory/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region MerchantSolicitation
    AddMerchantSolicitation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantSolicitation/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantSolicitation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantSolicitation/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantSolicitation(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/MerchantSolicitation/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantSolicitation(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/MerchantSolicitation/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region ProspectProposal
    GetProspectProposalUrl(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL(`/ProspectProposal/GetUrl`), payload).then(
          response => {
            resolve(response.data.ResponseDetail);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    GetProspectProposal(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL(`/ProspectProposal/Get?id=${payload.id}`), payload).then(
          response => {
            resolve(response.data.ResponseDetail);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    ListProspectProposal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ProspectProposal/List?idProspect=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region User
    AddUserInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL("/UserInternal/Add"), payload.userInternal)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteUserInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/UserInternal/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetUserInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/UserInternal/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListUserInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/UserInternal/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListarParceiroAtendimentoCategoriaDropDown(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ParceiroAtendimentoCategoria/ListDropDown`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListarParceiroAtendimentoCategoria(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ParceiroAtendimentoCategoria/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AdicionarParceiroAtendimentoCategoria(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/ParceiroAtendimentoCategoria/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BuscarParceiroAtendimentoCategoria(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ParceiroAtendimentoCategoria/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AlterarParceiroAtendimentoCategoria(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/ParceiroAtendimentoCategoria/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ExcluirParceiroAtendimentoCategoria(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/ParceiroAtendimentoCategoria/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AlterarParceiroAtendimento(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/ParceiroAtendimento/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AdicionarParceiroAtendimento(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/ParceiroAtendimento/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    RelatorioParceiroAtendimento(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/ParceiroAtendimento/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListarParceiroAtendimento(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/ParceiroAtendimento/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BuscarParceiroAtendimento(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ParceiroAtendimento/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateUserInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/UserInternal/Update"), payload.userInternal)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateUserInternalProfile(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/UserInternal/UpdateProfile"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateUserInternalMerchant(context, merchant) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/UserInternal/UpdateMerchant"), merchant)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ChangePassword(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/UserInternal/ChangePassword?token=${payload.Token}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region UserPartner

    ListUserPartner(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/UserPartner/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region TemplateEmail
    AddTemplateEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/TemplateEmail/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteTemplateEmail(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/TemplateEmail/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTemplateEmail(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/TemplateEmail/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTemplateEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/TemplateEmail/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateTemplateEmail(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/TemplateEmail/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Emailing
    AddEmailing(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Emailing/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetEmailing(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Emailing/Get"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListEmailing(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Emailing/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListEmailingGroupType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/EmailingGroupType/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListEmailsByGroupType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/EmailingGroupType/ListEmails"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportEmailing(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Emailing/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Limits
    AddLimits(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Limits/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteLimits(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Limits/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetLimits(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Limits/Get?id=${payload.Id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListLimits(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Limits/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UpdateLimits(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Limits/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AddAccessFuncLimits(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/AccessFuncLimits/Add`), payload.action)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAccessFuncLimits(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/AccessFuncLimits/Delete`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAccessFuncLimits(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/AccessFuncLimits/Get?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    LimitsFunctionality(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Limits/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAccessFuncLimits(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccessFuncLimits/Update`), payload.action)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Parameters
    ListParameters(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BusinessParameter/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    FindParameters(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BusinessParameter/Find"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddParameters(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/BusinessParameter/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateParameters(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/BusinessParameter/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region MerchantyDocType
    AddMerchantDocType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantDocType/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteMerchantDocType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/MerchantDocType/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantDocType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantDocType/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantDocType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantDocType/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantDocType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MerchantDocType/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region PartnerDocType

    AddPartnerDocType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/PartnerDocType/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPartnerDocType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/PartnerDocType/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerDocTypes(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/PartnerDocType/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePartnerDocType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/PartnerDocType/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeletePartnerDocType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/PartnerDocType/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region UserProfileInternal

    AddUserProfileInternal(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/UserProfileInternal/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetUserProfileInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/UserProfileInternal/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListUserProfileInternal(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/UserProfileInternal/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateUserProfileInternal(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/UserProfileInternal/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ListMerchantChecklist(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/Merchant/ListMerchantChecklist?idMerchant=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AddAccountsReceivableCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsReceivableCategory/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAccountsReceivableCategory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/AccountsReceivableCategory/Delete"), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAccountsReceivableCategory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/AccountsReceivableCategory/Get"), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAccountsReceivableCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsReceivableCategory/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAccountsReceivableCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/AccountsReceivableCategory/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Area

    AddArea(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Area/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteArea(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Area/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetArea(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Area/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListArea(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Area/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateArea(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Area/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Question

    AddQuestion(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Question/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteQuestion(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/Question/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetQuestion(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Question/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListQuestion(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Question/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateQuestion(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Question/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region SpecieType

    ListSpecieType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/SpecieType/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddSpecieType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/SpecieType/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetSpecieType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/SpecieType/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateSpecieType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/SpecieType/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Form

    AddForm(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Form/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteForm(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/Form/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetForm(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Form/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListForm(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Form/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateForm(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Form/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    // region RegisterType
    AddRegisterType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/RegisterType/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteRegisterType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/RegisterType/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetRegisterType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/RegisterType/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListRegisterType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/RegisterType/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateRegisterType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/RegisterType/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportRegisterType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/RegisterType/Report`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    // region Functionality
    AddFunctionality(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Functionality/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListFunctionality(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Functionality/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetFunctionality(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Functionality/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteFunctionality(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/Functionality/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateFunctionality(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Functionality/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // endregion

    //#region Answer

    GetAnswer(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Answer/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAnswer(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Answer/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Watcher & WatcherType

    AddWatcher(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Watcher/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteWatcher(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/Watcher/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetWatcher(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Watcher/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListWatcher(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Watcher/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateWatcher(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Watcher/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // WatcherType

    AddWatcherType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/WatcherType/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteWatcherType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/WatcherType/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetWatcherType(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/WatcherType/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListWatcherType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/WatcherType/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateWatcherType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/WatcherType/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region HealthCheck

    AddHealthCheck(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/HealthCheck/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteHealthCheck(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL("/HealthCheck/Delete"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetHealthCheck(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/HealthCheck/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListHealthCheck(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/HealthCheck/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateHealthCheck(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/HealthCheck/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region AdvancePayment

    ListAdvancePayment(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AdvancePayment/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportAdvancePayment(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AdvancePayment/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region

    ListMerchantHistory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Merchant/ListMerchantHistory"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region Ticket
    AddTicket(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Ticket/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTicket(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Ticket/Get"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTicket(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Ticket/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddFieldType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/FieldType/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListFieldType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/FieldType/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetFieldType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/FieldType/Get"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateFieldType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/FieldType/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteFieldType(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(ApiHandler.URL(`/FieldType/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddField(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Field/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListField(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Field/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetField(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Field/Get"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateField(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Field/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteField(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(ApiHandler.URL(`/Field/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportTicket(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Ticket/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Util
    GetShortUrl(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(ApiHandler.URL(`/Util/Shortener/Get?url=${payload.url}`), payload).then(
          response => {
            resolve(response.data.ResponseDetail);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    GetSignature(_context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(ApiHandler.URL(`/Util/Signature/Get`), payload).then(
          response => {
            resolve(response.data.ResponseDetail);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    GatewayListCreditCard(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/Gateway/ListCreditCard"), {})
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantMetrics(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/ClientMaintenance/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantMetrics(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/ClientMaintenance/Report`), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListSellerMetrics() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/SellerMetric/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListGateway() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/Gateway/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPayableCategories() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/AccountsPayableCategory/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListBankAccounts(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/BankAccounts/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListBankAccountsS2P(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/BankAccounts/ListS2PAccounts"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCity(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Util/City/List?stateInitials=${payload.stateInitials}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListState(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Util/State/List?idCountry=${payload.idCountry}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCountry() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/Country/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCep(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(`https://viacep.com.br/ws/${payload.zipCode}/json/`, {
            transformRequest: (data, headers) => {
              delete headers.common["X-INTERNAL-KEY"];
              return data;
            }
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/MerchantType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAccountType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/AccountType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/PartnerType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerStatus() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/PartnerStatus/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerStatusHistory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Partner/ListPartnerStatusHistory"), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //TODO /Util/PaymentMethod/List
    ListPaymentMethod() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/PaymentMethod/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTaxType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/TaxType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListBillingType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/BillingType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListProspectHistoryStatus() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/ProspectHistoryStatus/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerDocTypeUtil() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/PartnerDocType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPartnerDocStatus() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/PartnerDocStatus/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetNotificationInternal() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/NotificationInternal/Get"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantSolicitationStatus() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/MerchantSolicitationStatus/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListApplication() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/Application/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListOutgoType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/OutgoType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListBrand() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/Brand/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Country
    AddCountry(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Country/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCountry(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Country/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCountry(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Country/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CountryList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Country/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateCountry(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Country/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region State
    AddState(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/State/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteState(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/State/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetState(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/State/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    StateList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/State/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateState(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/State/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region City
    AddCity(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/City/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCity(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/City/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCity(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/City/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CityList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/City/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateCity(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/City/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Bank
    AddBank(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Bank/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteBank(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Bank/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBank(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Bank/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BankList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Bank/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateBank(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Bank/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BankReport(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Bank/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region agencies

    AddAgency(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Agencia/Adicionar"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AgencyList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Agencia/Listar"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UpdateAgency(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Agencia/Atualizar"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    DeleteAgency(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Agencia/Excluir?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion

    //#region blocklist
    ListBlocklist(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Blocklist/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AdicionarBlocklist(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Blocklist/Adicionar"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AtualizarBlocklist(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Blocklist/Atualizar"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBlocklist(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Blocklist/Get?Id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeletarBlocklist(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Blocklist/Deletar?Id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeletarBlockListMerchantPreview(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Blocklist/DeleteByIdentity"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region Gateway
    AddGateway(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Gateway/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateEnabled(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL(`/Gateway/UpdateEnabled`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetGateway(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Gateway/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GatewayList(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Gateway/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateGateway(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/Gateway/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region TypeReceipt
    ListTypeReceipt(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/TypeReceipt/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region TransferBankAccounts
    UpdateTransferBankAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/TransferBankAccounts/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GenerateRemittanceTransferBankAccounts(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/TransferBankAccounts/GenerateRemittance?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransferBankAccounts(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/TransferBankAccounts/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddTransferBankAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/TransferBankAccounts/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTransferBankAccounts(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/TransferBankAccounts/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteTransferBankAccounts(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/TransferBankAccounts/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region TransferRegister
    ListTransferRegister(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/TransferRegister/ListRegister"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListTransferType(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Util/TransferType/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTransferRegister(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/TransferRegister/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateTransferRegister(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/TransferRegister/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportTransferRegister(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/TransferRegister/Report"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region MCC
    ListMCC(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/MCC/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail.Objects);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region AccountsReceivable
    ListAccountsReceivable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsReceivable/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    CalculateTaxes(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsPayable/CalculateTaxes"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    CalculateNetValue(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsPayable/CalculateNetValue"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AddAccountsReceivable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsReceivable/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AddAccountPayable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          //.post("https://localhost:5001/v2/AccountsPayable/Add", payload)
          .post(ApiHandler.URL("/AccountsPayable/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAccountPayable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          //.post("https://localhost:5001/v2/AccountsPayable/Add", payload)
          .put(ApiHandler.URL("/AccountsPayable/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddAccountPayableWithIdBankStatementDetails(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsPayable/AddWithIdBankStatementDetails"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAccountsPayable(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/AccountsPayable/Delete?id=${payload.id}`), payload)
          //.delete(`https://localhost:5001/v2/AccountsPayable/Delete?id=${payload.id}`, payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ListAccountsPayable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          //.get("https://localhost:5001/v2/AccountsPayable/List", {
          .get(ApiHandler.URL("/AccountsPayable/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAccountsPayable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsPayable/Get"), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region AccountsPayableCategory
    ListAccountsPayableCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsPayableCategory/List"), {
            params: payload.params
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAccountsPayableCategory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/AccountsPayableCategory/Get"), {
            params: payload
          })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateAccountsPayableCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/AccountsPayableCategory/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddAccountsPayableCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsPayableCategory/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAccountsPayableCategory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/AccountsPayableCategory/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#region AccountsPayableConciliation
    ListAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsPayableConciliation/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    GetAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsPayableConciliation/Get"), { params: { id: payload.id } })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    AddAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsPayableConciliation/Add"), payload)
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    UpdateAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/AccountsPayableConciliation/Update"), payload)
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    DeleteAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(ApiHandler.URL(`/AccountsPayableConciliation/Delete?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    DeactivateAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccountsPayableConciliation/Deactivate?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ActivateAccountsPayableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccountsPayableConciliation/Activate?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ListAccountsPayableConciliationEntryCategories(_context) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/EntryCategory/List"))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    GetBankAccountBanks(_context) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/BankAccounts/Banks"))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ListReceivableCategories() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/AccountsReceivableCategory/List"), { params: { RowsPerPage: 999 } })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsReceivableConciliation/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    GetAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/AccountsReceivableConciliation/Get"), { params: { id: payload.id } })
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    AddAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/AccountsReceivableConciliation/Add"), payload)
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    UpdateAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/AccountsReceivableConciliation/Update"), payload)
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    DeleteAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(ApiHandler.URL(`/AccountsReceivableConciliation/Delete?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    DeactivateAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccountsReceivableConciliation/Deactivate?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    ActivateAccountsReceivableConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/AccountsReceivableConciliation/Activate?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) reject(response.data);
            else resolve(response.data.ResponseDetail);
          })
          .catch(error => reject(error));
      });
    },
    //#endregion
    //#endregion

    //#region CashFlow
    ListCashFlow(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/CashFlow/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region MerchantLimits
    ListMerchantLimits(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantLimits/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetMerchantLimits(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantLimits/Get?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantLimits(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MerchantLimits/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    //#region BankAccount
    ListBankAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BankAccount/ListBAPage"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListS2PBankAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BankAccount/ListS2P"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBankAccount(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/BankAccount/Get"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBankAccountSummary(context, dateToSummarize) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/BankAccount/GetSummary"), { params: { dateToSummarize: dateToSummarize } })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateBankAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/BankAccount/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddBankAccount(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/BankAccount/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteBankAccount(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL(`/BankAccount/Delete`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region CustomerServiceCategory
    AddCustomerServiceCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/CustomerServiceCategory/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCustomerServiceCategory(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/CustomerServiceCategory/Delete`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetCustomerServiceCategory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/CustomerServiceCategory/Get?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListCustomerServiceCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CustomerServiceCategory/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateCustomerServiceCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/CustomerServiceCategory/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion CommissionCompetence
    //#region DoublePayment
    GetDoublePayment(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/DoublePayment/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListDoublePayment(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/DoublePayment/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportDoublePayment(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/DoublePayment/Report"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion
    //#region MerchantContact
    ListMerchantContact(_context, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        axios
        .get(ApiHandler.URL("/MerchantContact/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetMerchantContact(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantContact/Get?id=${payload.id}`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ListContactCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/ContactCategory/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region MerchantUser
    ListMerchantUser(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantUser/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListUserProfile(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/UserProfile/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ResendEmailMerchantUser(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantUser/ResendEmail"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region DDA
    ListDDA(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/BankSlip/GetDDA"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region MensalidadeIsencao
    ListMensalidadeIsencao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MensalidadeIsencao/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ObterMerchantMensalidadeIsencao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MensalidadeIsencao/ObterMerchant"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddMensalidadeIsencao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MensalidadeIsencao/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMensalidadeIsencao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MensalidadeIsencao/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    EncerrarMensalidadeIsencao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL("/MensalidadeIsencao/Encerrar"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region LancamentoManual
    ListLancamentoManual(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/LancamentoManual/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddLancamentoManual(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/LancamentoManual/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListarCategoriasLancamentoManual() {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/LancamentoManual/ListarCategorias"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListarUsuariosLancamentoManual() {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/LancamentoManual/ListarUsuarios"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ObterCalendarioLancamentoManual() {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/LancamentoManual/ObterCalendario"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ObterMerchantLancamentoManual(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/LancamentoManual/ObterMerchant"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region Subscription
    GetMerchantSubscription(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Subscription/Get`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantSubscription(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Subscription/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportMerchantSubscription(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Subscription/Report"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListSubscriptionStatus(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Util/SubscriptionStatus/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region Negotiation & MerchantNegotiation
    ListNegotiation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNegotiation/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListNegotiationWithTransaction(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNegotiation/ListWithTransaction"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportNegotiation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNegotiation/Report"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddMerchantNegotiation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantNegotiation/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteMerchantNegotiation(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/MerchantNegotiation/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region Finacial View & Income
    ListIncome(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Income/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReportIncome(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Income/Report"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion Finacial View & Income
    //#region Notification
    ListTransactionNotification(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNotification/ListTransactionNotification"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListNotifications(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantNotification/List"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion Notification
    //#region BackgroundCheck
    ListBackgroundCheck(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/BackgroundCheck/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion BackgroundCheck
    //#region BankConciliation
    ListBankConciliation(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/BankConciliation/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListUnconciliatedReceivable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/BankConciliation/ListUnconciliatedReceivable`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListUnconciliatedPayable(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/BankConciliation/ListUnconciliatedPayable`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBankConciliation(_context, idBankStatement) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/BankConciliation/Get?idBankStatementDetails=${idBankStatement}`), {})
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Conciliate(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/BankConciliation/Conciliate`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Unconciliate(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/BankConciliation/Unconciliate`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion BankConciliation
    //#region Provider Internal
    AddProviderInternal(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL("/Provider/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteFileProviderInternal(context, id) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Provider/DeleteFileProviderInternal?id=${id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteProviderInternal(context, id) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Provider/Delete?id=${id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetProviderInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Provider/Get?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetProviderByNameIdentity(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Provider/GetProviderByNameIdentity?name=${payload.name}&identity=${payload.identity}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetPaymentMethodProviderInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL(`/Provider/GetPaymentMethodProviderInternal`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ListProviderInternal(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Provider/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListPaymentProviderInternalType() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Provider/ListPaymentProviderInternal"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListProviderTypeInternal() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/Provider/ListProviderType"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateProviderInternal(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/Provider/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    QueryProviderCNPJ(_context, identity) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/Provider/QueryCNPJ?identity=${identity}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    TransferenciaRecusadaListar(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/TransferenciaRecusada/Listar`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    MotivosRecusaListar() {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/TransferenciaRecusada/MotivosRecusaListar"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    RemoverTransferenciaRecusada(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL("/TransferenciaRecusada/Atualizar"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BuscarTransferenciaRecusada(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/TransferenciaRecusada/Buscar"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    UpdateMerchantPreviewResposible(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/MerchantPreview/Update`), payload)//apontei pra minha API no BackEnd
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#region PixDireto
    PixDiretoEmContaListar(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/PixDiretoEmConta/Listar`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PixDiretoEmContaAtualizar(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/PixDiretoEmConta/Atualizar`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PixDiretoEmContaEstornar(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/PixDiretoEmConta/Estornar`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    PixDiretoEmContaBuscarValorTotalPorStatus(_context, idStatus) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/PixDiretoEmConta/BuscarValorTotalPorStatus/${idStatus}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion

    ListAlertaMerchant(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/AlertaMerchant/Listar`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListAlertaMerchantPorMerchant(_context, idMerchant) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/AlertaMerchant/ListarPorMerchant?idMerchant=${idMerchant}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ResolverAlerta(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/AlertaMerchant/ResolverAlerta`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ListMerchantMaquina(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/MerchantMaquina/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateMerchantMaquinaSituacao(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL(`/MerchantMaquina/AtualizarSituacao`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AddMaquina(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Maquina/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMaquina(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/Maquina/List"), { params: payload.params })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UpdateMaquina(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/Maquina/Update"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetMerchantMaquina(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/MerchantMaquina/Get?idMerchantMaquina=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteMaquina(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/Maquina/Delete?id=${payload.id}`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ReservarMaquinas(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/MerchantMaquina/ReservarMaquinas"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    VerificarSeJaExisteMerchantMaquina(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL("/MerchantMaquina/VerificarSeJaExisteMerchantMaquina"), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //#endregion
    //#region CategoriasDoFornecedor
    AddCategoriasDoFornecedor(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .post(ApiHandler.URL("/CategoriasDosFornecedores/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListarCategoriasDoFornecedor(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/CategoriasDosFornecedores/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    BuscarCategoriasDoFornecedor(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/CategoriasDosFornecedores/Get?Id=${payload}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    EditarCategoriasDoFornecedor(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/CategoriasDosFornecedores/Update`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteCategoriasDoFornecedor(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .put(ApiHandler.URL(`/CategoriasDosFornecedores/Delete`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListMerchantAntifraudeCategory(_context) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL("/MerchantAntifraudeCategory/List"))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //#endregion
    //#region ContactCategory
    AddContactCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(ApiHandler.URL("/ContactCategory/Add"), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteContactCategory(_context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .delete(ApiHandler.URL(`/ContactCategory/Delete`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetContactCategory(context, payload) {
      return new Promise(function (resolve, reject) {
        axios
          .get(ApiHandler.URL(`/ContactCategory/Get?id=${payload.id}`))
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    ListContactCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(ApiHandler.URL(`/ContactCategory/List`), { params: payload })
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateContactCategory(_context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(ApiHandler.URL(`/ContactCategory/Update`), payload)
          .then(response => {
            if (response.data.HasError) {
              reject(response.data);
            } else {
              resolve(response.data.ResponseDetail);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js